import moment from 'moment';
import { DateFilter } from 'src/types';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';

interface IGetRangeParams extends DateFilter {
  type: moment.unitOfTime.DurationConstructor;
}

/**
 * getRange
 * - get an array of dates between two dates
 * reference: https://stackoverflow.com/a/57567327
 */
export const getRange = ({ startDate, endDate, type }: IGetRangeParams) => {
  if (
    isEmpty(startDate) ||
    isEmpty(endDate) ||
    isEmpty(type) ||
    !isString(type) ||
    !isString(startDate) ||
    !isString(endDate)
  ) {
    return [];
  }

  try {
    const fromDate = moment(startDate);
    const toDate = moment(endDate);
    const diff = toDate.diff(fromDate, type);
    const range = [];

    for (let i = 0; i < diff; i++) {
      range.push(moment(startDate).add(i, type)?.toISOString());
    }

    return range;
  } catch (error) {
    const tError = error as Error;

    throw new Error('getRange Error', {
      cause: {
        eCause: tError?.cause,
        eMessage: tError?.message,
        eStack: tError?.stack,
        eName: tError?.name,
      },
    });
  }
};
